import { Box } from "@mui/system";
import React from "react";
import Typography from "@mui/material/Typography";
import HoverButton from "../HoverButton";
import EastIconArrow from "../../assets/east.svg";
import image from "../../assets/image2.png";
import { InstaOtherProperties } from "../../api/Redirection";

const style = {
  mainContainer: {
    maxWidth: "1440px",
    width: "90%",
    paddingTop: {
      xl: "70px",
      md: "70px",
      sm: "50px",
      xs: "50px",
    },
    paddingBottom: {
      xl: "70px",
      md: "70px",
      sm: "50px",
      xs: "50px",
    },

    display: "flex",
    justifyContent: "center",
    boxSizing: "border-box",
    alignItems: "center",
    flexDirection: {
      xs: "column-reverse",
      md: "row",
    },
    gap: { xs: 3, md: 20 },
  },
  property: {
    display: "flex",
    flexDirection: "column",
    width: "322px",

  },
  image: {
    width: {
      xs: "320px",
      sm: "681px",
    },
    maxWidth: "681px",
    height: "auto",
  },

  text: {
    title: {
      fontFamily: "Sora",
      fontSize: {
        xs: "14px",
        sm: "16px",
        md: "16px",
        lg: "16px",
        xl: "18px",
      },
      fontWeight: 400,
      textTransform: "uppercase",
      color: " rgba(24, 24, 24, 1)",
      marginBottom: "10px",
      letterSpacing: "2px",
    },
    quote: {
      fontFamily: "ZapfHumnst BT",
      fontSize: {
        xs: "24px",
        sm: "28px",
        md: "36px",
        lg: "40px",
        xl: "40px",
      },
      fontWeight: 400,
      lineHeight: "1.2",
      color: " rgba(24, 24, 24, 1)",
      marginBottom: "15px",
      width: "322px",
    },
    description: {
      fontFamily: "Sora",
      fontSize: { xs: "11px", sm: "13px" },
      fontWeight: 300,
      color: "rgba(76, 76, 76, 1)",
      lineHeight: "1.6",
      marginBottom: "20px",
      textAlign:"justify"
    },
  },
};

const OtherProperty = () => {
  return (
    <Box sx={style.mainContainer}>
      {/* <Box sx={style.propertyWrapper} > */}
      <Box sx={style.property}>
        <Typography sx={style.text.title}>OTHER PROPERTY</Typography>
        <Typography sx={style.text.quote}>Container home cliff 362</Typography>
        <Typography sx={style.text.description}>
          A luxurios 2-bedroom shipping container with Jacuzzi and Home Theatre.
          <br />
          <br />
          This house is made from three recycled shipping containers & the property boasts a vast floor plan and modern style interiors.
          <br />
          <br />
          A deicated indoor kids area with a vertical garden, tent-house, swing and a 25ft high ceiling height. The upper floor's sapce consist of home theatre, pool table, master bedroom, jacuzzi with a pictureseque view and a open to sky washroom.
        </Typography>
        <HoverButton
          onClick={() => window.open(InstaOtherProperties)}
          btnText={"Explore"}
          endIcon={
            <img
              src={EastIconArrow}
              alt=""
              style={{
                width: "25px",
                height: "25px",
                transform: "rotate(-50deg)",
              }}
            />
          }
        />
      </Box>
      <Box sx={style.image}>
        <img alt="" src={image} width={"100%"} />
      </Box>
    </Box>
  );
};

export default OtherProperty;
